/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_EanInputs */

const en_col_ean = /** @type {(inputs: Col_EanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EAN`)
};

/**
* | output |
* | --- |
* | "EAN" |
*
* @param {Col_EanInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const col_ean = /** @type {((inputs?: Col_EanInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_EanInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_col_ean(inputs)
});